/** @format */

import React from "react";

export default () => (
<svg width="24" height="19" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 1H3.89189L4.8 2.94595M8.43243 10.7297H20.4234C20.6253 10.7297 20.8073 10.6084 20.885 10.422L23.7115 3.63825C23.8488 3.30891 23.6068 2.94595 23.25 2.94595H4.8M8.43243 10.7297L4.8 2.94595M8.43243 10.7297L7.21009 13.1744C6.87764 13.8393 7.36114 14.6216 8.10452 14.6216H22.7027" stroke="#191919" stroke-width="1.5"/>
<circle cx="11.027" cy="18.5135" r="1.94595" fill="#191919"/>
<circle cx="18.8108" cy="18.5135" r="1.94595" fill="#191919"/>
</svg>

);
